import React, { Component } from 'react';
import { Card, Flex, WhiteSpace, Button, ActionSheet } from 'antd-mobile';
import iconAvatar from '../medias/avatar.svg';
import iconSwitch from '../medias/switch.svg';
import DataFetcher from '../utils/DataFetcher';
import CommonUtils from '../utils/CommonUtils';
import Constants from '../utils/Constants';
import StorageUtils from '../utils/StorageUtils';
import { createForm } from 'rc-form';
import '../styles/DelegateMine.css';


const history = require("history").createHashHistory()

class DelegateMine extends Component {
    constructor(props){
        super(props);
        this.state = {
            profile: {},
            delegateAccounts: [],
            delegateId: this.props.delegateId
        }
    }

    componentDidMount() {
        this.loadInitData()
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.delegateId !== this.props.delegateId) {
            this.setState({
                delegateId: nextProps.delegateId
            }, () => {
                this.loadInitData()
            })
        }
    }

    loadInitData = () => {
        this.loadProfile();
        this.loadDelegateAccounts();
    }

    loadProfile = () => {
        DataFetcher.delegateProfile({
            id: this.state.delegateId
        }, {
            success: (resp) => {
                this.setState({
                    profile: resp.data
                })
            }
        })
    }

    loadDelegateAccounts = () => {
        DataFetcher.delegateAccounts({
            success: (resp) => {
                this.setState({
                    delegateAccounts: resp.data
                })
            }
        })
    }

    handleSwitchClick = () => {
        const { delegateAccounts, profile } = this.state
        let filterAccounts = delegateAccounts.filter(item => item.id !== profile.id)
        let buttons = filterAccounts.map(item => `${item.delegateName}（${item.agentName}）`)
        if(profile.agentRole) {
            buttons = ['主帐号', ...buttons]
        }

        ActionSheet.showActionSheetWithOptions({
          options: buttons,
          title: '切换帐号',
          maskClosable: true,
        },
        (buttonIndex) => {
            if(buttons[buttonIndex] === '主帐号') {
                StorageUtils.storeStringToSession(Constants.Storage.HOME_SELECTED_TAB, 'homeTab')
                history.replace('/agent')
                return
            }

            if(!filterAccounts[buttonIndex]) return
            StorageUtils.storeStringToSession(Constants.Storage.DELEGATE_SELECTED_TAB, 'homeTab')
            history.replace(`/delegate/home/${filterAccounts[buttonIndex].id}`)
        });
    }

    doResolveDelegateType = (delegateType) => {
        if(delegateType === 'VIEWER') {
            return '查看'
        } else if(delegateType === 'OPERATOR') {
            return '运营'
        }
    }

    render() {
        const { profile, delegateAccounts } = this.state;
        return (
            <div className='page-delegate-mine'>
                <Card full>
                    <Card.Header
                        title={
                            <div className='wrapper-main'>
                                <div className='name word-ellipsis'>{profile.delegateNickName}</div>
                                <div className='mobile word-ellipsis'>{this.doResolveDelegateType(profile.delegateType)}</div>
                            </div>}
                        thumb={<img src={CommonUtils.isEmpty(profile.delegateAvatar)?iconAvatar:profile.delegateAvatar} alt="avatar"/>}
                    />
                    <Card.Body>
                        <div className='wrapper-info'>
                            <div className="subtitle">
                                <span className='text'>代理信息</span>
                            </div>
                            <WhiteSpace size="sm"/>
                            <Flex>
                                <Flex.Item>
                                    <span className="label">代理姓名：</span>
                                    <span className="value">{profile.agentName}</span>
                                </Flex.Item>
                                <Flex.Item>
                                    <span className="label">分成比例：</span>
                                    <span className="value">{profile.profitPoint}%</span>
                                </Flex.Item>
                            </Flex>
                            <WhiteSpace size="sm"/>
                            <Flex>
                                <Flex.Item>
                                    <span className="label">门店上限：</span>
                                    <span className="value">{profile.maxSites}</span>
                                </Flex.Item>
                                <Flex.Item>
                                    <span className="label">团队上限：</span>
                                    <span className="value">{profile.maxMembers}</span>
                                </Flex.Item>
                            </Flex>
                        </div>
                    </Card.Body>
                </Card>
                <WhiteSpace/>
                {(delegateAccounts&&delegateAccounts.length>1)||(profile.agentRole)?(
                    <div onClick={this.handleSwitchClick}>
                        <Button icon={<img src={iconSwitch} alt="switch"/>} style={{color: '#444'}}> 切换帐号</Button>
                    </div>
                ):(<div></div>)}
            </div>
        )
    }
}

export default createForm()(DelegateMine);


// WEBPACK FOOTER //
// ./src/modules/DelegateMine.js